<!-- <div class="banner-wrapper" *ngIf="isAppUser" (click)="openUrl()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div> -->
<div class="banner-wrapper" *ngIf="!isAppUser" (click)="openUrl()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ng-template #content>
  <div class="content" *ngIf="isSipSubscribed">
    <div class="text">
      Manage monthly contributions
    </div>
    <a [href]="vars.pageName?.match('home|stories|campaign') ? vars.appLink.app_flyer : vars.appLink.iOS" target="_blank" (click)="systemEvent()">
      <div class="download-img" *ngIf="!isMobile">
        <img data-src="/assets/images/sip/App-Store.png"  loading="lazy" alt="no image">
      </div>
    </a>
    <a [href]="vars.pageName?.match('home|stories|campaign')  ? vars.appLink.app_flyer_android : vars.appLink.android" target="_blank" (click)="systemEvent()">
      <div class="download-img" *ngIf="!isMobile" >
        <img data-src="/assets/images/sip/google-download.png" loading="lazy" alt="no image">
      </div>
    </a>
    <div *ngIf="isMobile">
      <a *ngIf="!vars.pageName?.match('home|stories|campaign')" [href]="isIos ? vars.appLink.iOS: vars.appLink.android" target="_blank" (click)="systemEvent()">
        <div class="download-img">
          <img [attr.data-src]="isIos ? '/assets/images/sip/App-Store.png':'/assets/images/sip/google-download.png'" loading="lazy" alt="no img">
        </div>
      </a>
      <a *ngIf="vars.pageName?.match('home|stories|campaign')" [href]="isIos ? vars.appLink.app_flyer: vars.appLink.app_flyer_android" target="_blank" (click)="systemEvent()">
        <div class="download-img">
          <img [attr.data-src]="isIos ? '/assets/images/sip/App-Store.png':'/assets/images/sip/google-download.png'" loading="lazy" alt="no img">
        </div>
      </a>
    </div>
  </div>
</ng-template>
